import type { ProjectUserPathParams } from '@si/types';
import { del, objectToQueryParams } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

export function useDeleteProjectUser() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation<
    void,
    Error,
    ProjectUserPathParams
  >({
    mutationFn: ({ projectId, projectUserId }: ProjectUserPathParams) =>
      del({
        url: `/projects/${projectId}/team${objectToQueryParams({ userProjectId: projectUserId })}`,
      }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getProjectUsers(variables.projectId),
      });
    },
  });

  const deleteProjectUser = useCallback(
    (params: ProjectUserPathParams) => mutate(params),
    [mutate]
  );

  return {
    deleteProjectUser,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
